<template>
    <md-card>
        <b-row class="pagination__card">
            <b-col cols="2" class="pagination__card-text"><span>{{ $t('common.rows_per_page') }} </span></b-col>
            <b-col cols="1">
                <md-field>
                <md-select :value="perPage" @input='updateValue' >
                    <md-option v-for="option in options" :key="option" :value="option">{{ option }}</md-option>
                </md-select>
                </md-field>
            </b-col>
            <b-col cols="1" class="pagination__card-info"><span>{{ totalItems }} of {{ total }}</span></b-col>
            <b-col cols="1" class="pagination__card-icon">
                <span class="pr-3" @click="hasPrevious && handlePage(PREVIOUS)" >
                    <md-icon class="fa fa-angle-left arrow-font" :class="`${ hasPrevious ? 'clickable' : ''}`"></md-icon>
                </span>
                <span class="px-2" @click="hasNext && handlePage(NEXT)">
                    <md-icon class="fa fa-angle-right arrow-font" :class="`${ hasNext ? 'clickable' : ''}`"></md-icon>
                </span>
            </b-col>
        </b-row>
    </md-card>
</template>

<script>

const PREVIOUS = 'previous'
const NEXT = 'next'

export default {
    props: {
        options: {
            type: Array,
            default: []
        },
        total: {
            type: Number,
            default: 0
        },
        perPage: {
            type: Number,
            default: 10
        },
        totalItems: {
            type: Number,
            default: 1
        },
        currentPage: {
            type: Number,
            default: 1
        },
        totalPages: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            PREVIOUS,
            NEXT,
            isNextPage: false,
            isPreviousPAge: false
        }
    },
    emits: ['update:per-page', 'update:current-page'],
    methods: {
        updateValue(value) {
            this.$emit('update:per-page', value)
        },
        handlePage(typePage) {
            if (typePage === PREVIOUS) {
                this.$emit('update:current-page', +this.currentPage - 1)
            } else {
                this.$emit('update:current-page', +this.currentPage + 1)
            }
        }
    },
    computed: {
        hasNext() {
            return this.totalPages > this.currentPage
        },
        hasPrevious() {
            return this.currentPage > 1
        }
    }
}
</script>

<style scoped>
    .pagination__card {
        display:flex; 
        justify-content: end; 
        align-items:center
    }

    .pagination__card-info {
        text-align:center
    }

    .clickable {
        color: black !important;
        cursor: pointer;
    }

    .pagination__card-icon {
        display: flex;
    }

    .pagination__card-text {
        text-align: right;
    }

    .arrow-font {
        font-family: 'FontAwesome' !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Partials/CPagination.vue